import { render, staticRenderFns } from "./managedInstructionAssignmentAssignedDialogAction.vue?vue&type=template&id=362d5a20"
import script from "./managedInstructionAssignmentAssignedDialogAction.vue?vue&type=script&lang=js"
export * from "./managedInstructionAssignmentAssignedDialogAction.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports